export function decodeInLoop(value: string): string {
  let decoded = value;
  let previousDecoded = '';

  do {
    previousDecoded = decoded;
    decoded = decodeURIComponent(decoded);
  } while (decoded !== previousDecoded);

  return decoded;
}
